var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c(
          "div",
          {
            staticClass: "page-header-top-container",
            staticStyle: { width: "100% !important" }
          },
          [
            _c("div", { staticClass: "page-name" }, [
              _vm._v(_vm._s(_vm.pageTitle))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary waves-effect pull-right",
                attrs: { type: "submit" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.buttonBack()
                  }
                }
              },
              [_vm._v("Back")]
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c(
            "div",
            { staticClass: "forms-container add_user_forms_container" },
            [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _vm.editId != 0
                        ? [
                            _c("span", { staticClass: "form-control" }, [
                              _vm._v(_vm._s(_vm.notificationType.text))
                            ])
                          ]
                        : [
                            _c("v-select", {
                              attrs: {
                                name: "notificationType",
                                id: "notificationType",
                                label: "text",
                                options: _vm.notificationTypeArr,
                                clearable: false,
                                searchable: false,
                                placeholder: "Select Notification Type"
                              },
                              on: {
                                input: function($event) {
                                  _vm.notificationTypeError = ""
                                }
                              },
                              model: {
                                value: _vm.notificationType,
                                callback: function($$v) {
                                  _vm.notificationType = $$v
                                },
                                expression: "notificationType"
                              }
                            })
                          ],
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.notificationTypeError))
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _vm.editId != 0
                        ? [
                            _c("span", { staticClass: "form-control" }, [
                              _vm._v(_vm._s(_vm.customerId.text))
                            ])
                          ]
                        : [
                            _c("v-select", {
                              attrs: {
                                name: "customerId",
                                id: "customerId",
                                label: "text",
                                filterable: true,
                                options: _vm.customerArr,
                                clearable: false,
                                placeholder: "Select Customer"
                              },
                              on: {
                                input: function($event) {
                                  return _vm.onChnageCustomer()
                                }
                              },
                              model: {
                                value: _vm.customerId,
                                callback: function($$v) {
                                  _vm.customerId = $$v
                                },
                                expression: "customerId"
                              }
                            })
                          ],
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.customerError))
                      ])
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-tags-input", {
                        attrs: {
                          tags: _vm.toEmailTagsArr,
                          validation: _vm.validation,
                          placeholder: ""
                        },
                        on: {
                          "tags-changed": function(newTags) {
                            return (_vm.toEmailTagsArr = newTags)
                          },
                          "before-adding-tag": _vm.checkToEmailTag
                        },
                        model: {
                          value: _vm.toEmail,
                          callback: function($$v) {
                            _vm.toEmail = $$v
                          },
                          expression: "toEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.toEmailError))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-tags-input", {
                        attrs: {
                          tags: _vm.ccEmailTagsArr,
                          validation: _vm.validation,
                          placeholder: ""
                        },
                        on: {
                          "tags-changed": function(newTags) {
                            return (_vm.ccEmailTagsArr = newTags)
                          },
                          "before-adding-tag": _vm.checkCCEmailTag
                        },
                        model: {
                          value: _vm.ccEmail,
                          callback: function($$v) {
                            _vm.ccEmail = $$v
                          },
                          expression: "ccEmail"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "help is-danger" }, [
                        _vm._v(_vm._s(_vm.ccEmailError))
                      ])
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "row clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "button-demo" }, [
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.save,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.save },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdateFormEmailManager("Save")
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showSaveAndContinue,
                      expression: "showSaveAndContinue"
                    }
                  ],
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "addBenifitBtn",
                    disabled: _vm.disableButtons.saveAndContinue,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.saveAndContinue },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addUpdateFormEmailManager("Save And Continue")
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-primary my-1 ms-2",
                  attrs: {
                    id: "CancelBenifit",
                    disabled: _vm.disableButtons.cancel,
                    type: "submit"
                  },
                  domProps: { value: _vm.buttonNames.cancel },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.buttonBack.apply(null, arguments)
                    }
                  }
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("app-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Notification Type :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("Customer :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("To Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label" }, [_vm._v("CC Email :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row clearfix" }, [
      _c("div", { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eed12d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eed12d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FormEmailManagerMaster/AddUpdateFormEmailManager.vue
// module id = null
// module chunks = 